import { useState } from 'react';
import { NavLink, useNavigate, Link } from 'react-router-dom';
import { NewCampaignModal } from '@/components/modals/NewCampaignModal';
import { NewCreativeModal } from '@/components/modals/NewCreativeModal';
const NAV_ITEMS = [
  { to: '/', icon: 'dashboard', label: 'Dashboard' },
  { to: '/formats', icon: 'grid_view', label: 'Formats' },
  { to: '/campaigns', icon: 'campaign', label: 'Campaigns' },
  { to: '/creatives', icon: 'auto_awesome', label: 'Creatives' },
  { to: '/renders', icon: 'movie', label: 'Renders' },
  { to: '/assets', icon: 'folder', label: 'Assets' },
  { to: '/analytics', icon: 'leaderboard', label: 'Analytics' },
];

export default function Sidebar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isNewCreativeOpen, setIsNewCreativeOpen] = useState(false);
  const [isNewCampaignOpen, setIsNewCampaignOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <aside className="h-screen w-64 fixed left-0 top-0 bg-white border-r border-stone-200 hidden md:flex flex-col p-6 overflow-y-auto z-40">
      {/* Brand */}
      <Link to="/" className="mb-10 block cursor-pointer hover:opacity-90 transition-opacity">
        <img
          src="/aspectly-logo-horizontal.svg"
          alt="Aspectly"
          className="h-9 w-auto max-w-[180px] object-contain shrink-0"
        />
      </Link>

      {/* New button */}
      <div className="pb-4 mb-4 border-b border-stone-100 relative">
        <button
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          className="w-full py-3 bg-primary text-on-primary font-bold rounded-xl hover:bg-primary-dim transition-all shadow-md shadow-primary/20 flex items-center justify-center gap-2 cursor-pointer"
        >
          <span className="material-symbols-outlined text-sm">add</span>
          New
        </button>
        {isDropdownOpen && (
          <div className="absolute top-full left-0 mt-2 w-full bg-surface-container-lowest border border-outline-variant/20 rounded-xl shadow-xl z-[70] overflow-hidden">
            <button
              onClick={() => {
                setIsDropdownOpen(false);
                setIsNewCreativeOpen(true);
              }}
              className="w-full text-left px-4 py-3 text-sm font-bold text-on-surface hover:bg-surface-container transition-colors cursor-pointer"
            >
              Creative
            </button>
            <button
              onClick={() => {
                setIsDropdownOpen(false);
                setIsNewCampaignOpen(true);
              }}
              className="w-full text-left px-4 py-3 text-sm font-bold text-on-surface hover:bg-surface-container transition-colors cursor-pointer"
            >
              Campaign
            </button>
          </div>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-grow space-y-1">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 text-sm font-bold rounded-lg transition-colors ${
                isActive
                  ? 'text-primary font-black border-r-4 border-primary bg-primary-container'
                  : 'text-on-surface-variant hover:text-primary hover:bg-primary-container'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span
                  className="material-symbols-outlined"
                  style={isActive ? { fontVariationSettings: "'FILL' 1" } : undefined}
                >
                  {item.icon}
                </span>
                {item.label}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <NewCampaignModal
        isOpen={isNewCampaignOpen}
        onClose={() => setIsNewCampaignOpen(false)}
        onCampaignCreated={() => navigate('/campaigns')}
      />
      <NewCreativeModal
        isOpen={isNewCreativeOpen}
        onClose={() => setIsNewCreativeOpen(false)}
        onCreated={(created) => navigate(`/creatives/${created.id}`)}
      />
    </aside>
  );
}
